webpackJsonp([15],Array(29).concat([
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins__ = __webpack_require__(373);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["b" /* state */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__,
  plugins: __WEBPACK_IMPORTED_MODULE_6__plugins__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeOutlet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(29);



var URL = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.apiUrl + '/api/v1';

var login = function login(data) {
  var params = {
    'username': data.username,
    'password': data.password
  };

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(URL + '/login', params, null).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGIN', response.body.data);
  });
};

var logout = function logout() {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + '/logout', {
    headers: headers
  }).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGOUT');
  }).catch(function (err) {
    console.log(err);
  });
};

var changeOutlet = function changeOutlet(outletID) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  console.log(headers);
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + '/change-outlet/' + outletID, {
    headers: headers
  }).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('changeOutlet', response.body);
  }).catch(function (err) {
    console.log(err);
  });
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDaily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDailyThirdParty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMonthly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPrimaryIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDailyProductSales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMonthlyProductSales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getYearly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDateRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDateRangeCategorySales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDateRangeProductSales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return printDailyBill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return syncToHarmony; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(29);



var URL = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.apiUrl + '/api/v1';

var getDaily = function getDaily(date) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/transaction/filter/day?date=' + date), {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log(err);
  });
};

var getDailyThirdParty = function getDailyThirdParty(date) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/transaction/filter/third-party?date=' + date), {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log(err);
  });
};

var getMonthly = function getMonthly(date) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/transaction/filter/month?date=' + date), {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log(err);
  });
};

var getPrimaryIncome = function getPrimaryIncome(date) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/report/primary?date=' + date), {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log(err);
  });
};

var getDailyProductSales = function getDailyProductSales(date) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  var outlets = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.isAllOutlet ? -1 : __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.activeOutletID;
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/transaction/report/daily?date=' + date + '&outlets=' + outlets), {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log(err);
  });
};

var getMonthlyProductSales = function getMonthlyProductSales(date) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  var outlets = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.isAllOutlet ? -1 : __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.activeOutletID;
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/transaction/report/monthly?date=' + date + '&outlets=' + outlets), {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log(err);
  });
};

var getYearly = function getYearly(date) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/transaction/filter/yearly?date=' + date), {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log(err);
  });
};

var getDateRange = function getDateRange(dateStart, dateEnd) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/transaction/filter/custom?dateStart=' + dateStart + '&dateEnd=' + dateEnd), {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log(err);
  });
};

var getDateRangeCategorySales = function getDateRangeCategorySales(dateStart, dateEnd) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/report/product-type?dateStart=' + dateStart + '&dateEnd=' + dateEnd), {
    headers: headers
  }).then(function (response) {
    return response.body;
  }).catch(function (err) {
    console.log(err);
  });
};

var getDateRangeProductSales = function getDateRangeProductSales(dateStart, dateEnd) {
  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  var outlets = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.isAllOutlet ? -1 : __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.activeOutletID;
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(URL + ('/admin/transaction/report/custom?dateStart=' + dateStart + '&dateEnd=' + dateEnd + '&outlets=' + outlets), {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log(err);
  });
};

var printDailyBill = function printDailyBill() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  var params = {
    'id': data.id,
    'date': data.date,
    'products': data.products,
    'note': data.note || ''
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('http://localhost:8000/api/v1/printBill', params, {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log('error print');
    console.log(err);
  });
};

var syncToHarmony = function syncToHarmony() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.auth.user.api_token
  };
  var params = {
    'date': data.date
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(URL + '/admin/transaction/sync/harmony', params, {
    headers: headers
  }).then(function (response) {
    return response.body.data;
  }).catch(function (err) {
    console.log('error sync to harmony');
    console.log(err);
  });
};

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);


var STORAGE_KEY = 'coffeeketjil';

var syncedData = {
  auth: {
    isLoggedIn: false,
    isAllOutlet: false,
    user: {},
    externalApiKey: ''
  }
};

var notSyncedData = {
  appname: 'Coffee Ketjil',
  apiUrl: 'https://pos.kopiketjil.com',
  externalApiUrl: 'https://api.kopiketjil.com'
};

if (localStorage.getItem(STORAGE_KEY)) {
  syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY));
}

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(syncedData, notSyncedData);

/***/ }),
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(377);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(47);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-aside',
  data: function data() {
    return {
      outlets: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.outlets
    };
  },

  methods: {
    isActiveOutlet: function isActiveOutlet(outletID) {
      return outletID === __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.activeOutletID;
    },
    onOutletClick: function onOutletClick(outletID) {
      if (outletID !== -1) {
        Object(__WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* changeOutlet */])(outletID).then(function (response) {
          console.log(response);
        });
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('changeIsAllOutlet', false);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('changeIsAllOutlet', true);
      }
    }
  },
  computed: {
    isOwner: function isOwner() {
      return this.$store.state.auth.user.username === 'owner';
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-footer',
  data: function data() {
    return {
      currentVersion: '1.0.8',
      title: 'Checkout our New Release!'
    };
  },

  methods: {
    getTitle: function getTitle() {
      return this.title;
    },
    gotoConsole: function gotoConsole() {
      this.$router.push('/console');
    }
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__ = __webpack_require__(387);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-header',
  components: {
    HeaderDropdown: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__["a" /* default */]
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(47);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown',
  data: function data() {
    return { itemsCount: 42 };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__services_auth__["c" /* logout */])().then(function (response) {
        _this.$router.push('/login');
      });
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__ = __webpack_require__(418);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */],
    SidebarNavLabel: __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__["a" /* default */]
  },
  computed: {
    auth: function auth() {
      return this.$store.state.auth || {};
    },
    user: function user() {
      return this.auth.user || {};
    },
    roleId: function roleId() {
      return this.user.role_id;
    },
    rules: function rules() {
      return {
        5: ['Dashboard']
      };
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    checkUrl: function checkUrl(menu) {
      if (!this.rules[this.roleId]) {
        return true;
      }
      return this.rules[this.roleId].includes(menu);
    }
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89526baa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89526baa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89526baa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      return this.url.substring(0, 4) === 'http';
    },
    auth: function auth() {
      return this.$store.state.auth || {};
    },
    user: function user() {
      return this.auth.user || {};
    },
    isOwner: function isOwner() {
      return this.user.role_id === 3;
    },
    isFranchiseNav: function isFranchiseNav() {
      return this.url === '/external/franchise';
    }
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(127);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b6f8945_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b6f8945_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b6f8945_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  },
  methods: {
    hideMobile: function hideMobile() {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    }
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__ = __webpack_require__(123);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-label',
  components: {
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__["a" /* default */]
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '#'
    },
    icon: {
      type: String,
      default: 'fa fa-circle'
    },
    classes: {
      type: String,
      default: ''
    },
    label: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      var classes = {
        navItem: ['hidden-cn'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getClasses(this.classes))).join(' '),
        navLink: 'nav-label',
        icon: [this.icon ? this.icon : 'fa fa-circle', this.label.variant ? 'text-' + this.label.variant : '', this.label.class ? this.label.class : ''].join(' ')
      };
      return classes;
    }
  },
  methods: {
    getClasses: function getClasses(classes) {
      return classes ? classes.split(' ') : [];
    }
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_external_auth__ = __webpack_require__(425);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      error: ''
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__services_external_auth__["a" /* login */])().then(function (response) {
        Object(__WEBPACK_IMPORTED_MODULE_0__services_auth__["b" /* login */])(_this.credentials).then(function (response) {
          _this.$router.push('/');
        }).catch(function (exception) {
          console.log(exception);
        });
      });
    }
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_MonthlyChart__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_YearlyChart__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tableexport__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tableexport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tableexport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_dashboard__ = __webpack_require__(48);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    MonthlyChart: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_MonthlyChart__["a" /* default */],
    YearlyChart: __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_YearlyChart__["a" /* default */]
  },
  data: function data() {
    return {
      date: new Date(),
      month: new Date(),
      year: new Date(),
      dateStart: new Date(),
      dateEnd: new Date(),
      daily: {
        transactions: [],
        productSales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isLoaded: false,
        totalPrice: -1,
        paymentMethods: [],
        printBillLoading: false,
        syncToHarmonyLoading: false
      },
      dailyThirdParty: {
        transactions: [],
        productSales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isLoaded: false,
        totalPrice: -1,
        paymentMethods: [],
        printBillLoading: false
      },
      monthly: {
        transactions: [],
        productSales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isLoaded: false,
        totalPrice: -1,
        totalQuantity: -1,
        totalDiscount: -1,
        totalProductSales: -1
      },
      yearly: {
        transactions: [],
        productSales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isLoaded: false,
        totalPrice: -1,
        totalQuantity: -1,
        totalDiscount: -1,
        totalProductSales: -1
      },
      dateRange: {
        transactions: [],
        productSales: [],
        categorySales: [],
        isAvailableForExcel: false,
        isAvailableForExcelProductSales: false,
        isAvailableForExcelCategorySales: false,
        isLoaded: false,
        totalPrice: -1,
        paymentMethods: [],
        totalProductSales: -1
      },
      tableExport: null
    };
  },

  computed: {
    monthDate: function monthDate() {
      return this.moment(this.month, 'YYYY-MM');
    },
    activeOutlet: function activeOutlet() {
      return this.$store.state.auth.isAllOutlet ? 'All Outlet' : this.$store.getters.outlet.name;
    },
    disabledDates: function disabledDates() {
      return {
        to: this.dateStart
      };
    }
  },
  methods: {
    generateDailyReport: function generateDailyReport() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["a" /* getDaily */])(this.moment(this.date)).then(function (response) {
        _this.daily.transactions = response.transactions;
        _this.daily.isAvailableForExcel = true;
        _this.daily.isLoaded = true;
        _this.daily.totalPrice = response.totalFinalPrice;
        if (response.totalPerPaymentMethod) {
          _this.daily.paymentMethods = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(response.totalPerPaymentMethod).map(function (data) {
            return { name: data, value: response.totalPerPaymentMethod[data] };
          });
        }
        _this.removeAllButtonForExportDaily();
        _this.removeAllButtonForExportDailyCustom();
      }).catch(function (e) {
        _this.$toast('failed to fetch daily transactions on ' + _this.date);
        _this.daily.transactions = [];
      });
      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["b" /* getDailyProductSales */])(this.moment(this.date)).then(function (response) {
        _this.daily.productSales = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(response).map(function (key) {
          return response[key];
        });
        _this.daily.productSales.sort(function (a, b) {
          return b.quantity - a.quantity;
        });
        _this.daily.isAvailableForExcelProductSales = true;
        _this.calculateAllTotalDailyProductSalesQuantity();
        _this.removeAllButtonForExportDailyProductSales();
      }).catch(function (e) {
        _this.$toast('failed to fetch daily sales on ' + _this.day);
        _this.daily.productSales = [];
      });
    },
    generateDailyThirdPartyReport: function generateDailyThirdPartyReport() {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["c" /* getDailyThirdParty */])(this.moment(this.date)).then(function (response) {
        _this2.dailyThirdParty.transactions = response.transactions;
        _this2.dailyThirdParty.isAvailableForExcel = true;
        _this2.dailyThirdParty.isLoaded = true;
        _this2.dailyThirdParty.totalPrice = response.totalFinalPrice;
        if (response.totalPerPaymentMethod) {
          _this2.dailyThirdParty.paymentMethods = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(response.totalPerPaymentMethod).map(function (data) {
            return { name: data, value: response.totalPerPaymentMethod[data] };
          });
        }
        _this2.removeAllButtonForExportDaily();
        _this2.removeAllButtonForExportDailyCustom();
      }).catch(function (e) {
        _this2.$toast('failed to fetch daily transactions on ' + _this2.date);
        _this2.dailyThirdParty.transactions = [];
      });
    },
    generateMonthlyReport: function generateMonthlyReport() {
      var _this3 = this;

      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["g" /* getMonthly */])(this.monthDate).then(function (response) {
        _this3.monthly.transactions = response;
        _this3.monthly.isAvailableForExcel = true;
        _this3.monthly.isLoaded = true;
        _this3.calculateAllTotalAttributesMonthly();
        _this3.removeAllButtonForExportMonthly();
      }).catch(function (e) {
        _this3.$toast('failed to fetch monthly transactions on ' + _this3.month);
        _this3.month.transaction = [];
      });
      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["h" /* getMonthlyProductSales */])(this.monthDate).then(function (response) {
        _this3.monthly.productSales = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(response).map(function (key) {
          return response[key];
        });
        _this3.monthly.productSales.sort(function (a, b) {
          return b.quantity - a.quantity;
        });
        _this3.monthly.isAvailableForExcelProductSales = true;
        _this3.calculateAllTotalMonthlyProductSalesQuantity();
        _this3.removeAllButtonForExportMonthlyProductSales();
      }).catch(function (e) {
        _this3.$toast('failed to fetch monthly sales on ' + _this3.month);
        _this3.monthly.productSales = [];
      });
    },
    generateYearlyReport: function generateYearlyReport() {
      var _this4 = this;

      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["j" /* getYearly */])(this.moment(this.year, 'YYYY-MM')).then(function (response) {
        _this4.yearly.transactions = response;
        _this4.yearly.isAvailableForExcel = true;
        _this4.yearly.isLoaded = true;
        _this4.calculateAllTotalAttributesYearly();
        _this4.removeAllButtonForExportMonthly();
      }).catch(function (e) {
        _this4.$toast('failed to fetch year transactions on ' + _this4.year);
        _this4.yearly.transaction = [];
      });
    },
    generateDateRangeReport: function generateDateRangeReport() {
      var _this5 = this;

      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["d" /* getDateRange */])(this.moment(this.dateStart), this.moment(this.dateEnd)).then(function (response) {
        _this5.dateRange.transactions = response.transactions;
        _this5.dateRange.isAvailableForExcel = true;
        _this5.dateRange.isAvailableForExcelCategorySales = true;
        _this5.dateRange.isLoaded = true;
        _this5.dateRange.totalPrice = response.totalFinalPrice;
        if (response.totalPerPaymentMethod) {
          _this5.dateRange.paymentMethods = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(response.totalPerPaymentMethod).map(function (data) {
            return { name: data, value: response.totalPerPaymentMethod[data] };
          });
        }
        _this5.removeAllButtonForExportDateRange();
      }).catch(function (e) {
        _this5.$toast('failed to fetch date range transactions on ' + _this5.dateStart + ' - ' + _this5.dateEnd);
        _this5.daily.transactions = [];
      });
      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["e" /* getDateRangeCategorySales */])(this.moment(this.dateStart), this.moment(this.dateEnd)).then(function (response) {
        console.log(response);
        _this5.dateRange.categorySales = response.data;
      });
      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["f" /* getDateRangeProductSales */])(this.moment(this.dateStart), this.moment(this.dateEnd)).then(function (response) {
        _this5.dateRange.productSales = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(response).map(function (key) {
          return response[key];
        });
        _this5.dateRange.productSales.sort(function (a, b) {
          return b.quantity - a.quantity;
        });
        _this5.dateRange.isAvailableForExcelProductSales = true;
        _this5.calculateAllTotalDateRangeProductSalesQuantity();
        _this5.removeAllButtonForExportDateRangeProductSales();
      }).catch(function (e) {
        _this5.$toast('failed to fetch date range sales on ' + _this5.dateStart + ' - ' + _this5.dateEnd);
        _this5.dateRange.productSales = [];
      });
    },

    downloadAsExcelDaily: function downloadAsExcelDaily() {
      var custom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var elementId = custom ? 'table-daily-custom' : 'table-daily';
      this.tableExport = __WEBPACK_IMPORTED_MODULE_6_tableexport___default()(document.getElementById(elementId), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Daily Report-' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date).format('DDMMYYYY'),
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      });
      this.daily.isAvailableForExcel = false;
    },
    downloadJson: function downloadJson() {
      var _this6 = this;

      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["a" /* getDaily */])(this.moment(this.date)).then(function (response) {
        var dataStr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response, null, 2);
        var blob = new Blob([dataStr], { type: 'application/json' });
        var url = URL.createObjectURL(blob);

        var link = document.createElement('a');
        link.href = url;
        link.download = 'Daily Report-' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this6.date).format('DDMMYYYY') + 'data.json';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }).catch(function (e) {
        _this6.$toast('failed to download daily transactions on ' + _this6.date);
        _this6.daily.transactions = [];
      });
    },
    downloadAsExcelMonthly: function downloadAsExcelMonthly() {
      this.tableExport = __WEBPACK_IMPORTED_MODULE_6_tableexport___default()(document.getElementById('table-monthly'), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Monthly Report-' + this.month,
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      });
      this.monthly.isAvailableForExcel = false;
    },
    downloadAsExcelDailyProductSales: function downloadAsExcelDailyProductSales() {
      this.tableExport = __WEBPACK_IMPORTED_MODULE_6_tableexport___default()(document.getElementById('table-daily-product-sales'), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Daily Sales Report-' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date).format('DDMMYYYY'),
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      });
      this.daily.isAvailableForExcelProductSales = false;
    },
    downloadAsExcelMonthlyProductSales: function downloadAsExcelMonthlyProductSales() {
      this.tableExport = __WEBPACK_IMPORTED_MODULE_6_tableexport___default()(document.getElementById('table-monthly-product-sales'), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Monthly Sales Report-' + this.month,
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      });
      this.monthly.isAvailableForExcelProductSales = false;
    },
    downloadAsExcelDateRange: function downloadAsExcelDateRange() {
      var elementId = 'table-date-range';
      this.tableExport = __WEBPACK_IMPORTED_MODULE_6_tableexport___default()(document.getElementById(elementId), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Date Range Report-' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dateStart).format('DDMMYYYY') + '~' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dateEnd).format('DDMMYYYY'),
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      });
      this.daily.isAvailableForExcel = false;
    },
    downloadAsExcelDateRangeCategorySales: function downloadAsExcelDateRangeCategorySales() {
      var elementId = 'table-date-range-category-sales';
      this.tableExport = __WEBPACK_IMPORTED_MODULE_6_tableexport___default()(document.getElementById(elementId), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Date Range Category Sales Report-' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dateStart).format('DDMMYYYY') + '~' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dateEnd).format('DDMMYYYY'),
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      });
      this.monthly.isAvailableForExcelCategorySales = false;
    },
    downloadAsExcelDateRangeProductSales: function downloadAsExcelDateRangeProductSales() {
      this.tableExport = __WEBPACK_IMPORTED_MODULE_6_tableexport___default()(document.getElementById('table-date-range-product-sales'), {
        headers: true,
        footers: true,
        formats: ['xlsx', 'csv', 'txt'],
        filename: 'Date Range Sales Report-' + this.month,
        bootstrap: false,
        exportButtons: true,
        position: 'bottom',
        ignoreRows: null,
        ignoreCols: null,
        trimWhitespace: true
      });
      this.dateRange.isAvailableForExcelProductSales = false;
    },
    removeAllButtonForExportDaily: function removeAllButtonForExportDaily() {
      var parent = document.getElementById('table-daily');
      var child = document.getElementsByTagName('caption')[0];
      if (child != null) {
        parent.removeChild(child);
      }
    },
    removeAllButtonForExportDailyCustom: function removeAllButtonForExportDailyCustom() {
      var parent = document.getElementById('table-daily-custom');
      var child = document.getElementsByTagName('caption')[0];
      if (child != null) {
        parent.removeChild(child);
      }
    },
    removeAllButtonForExportMonthly: function removeAllButtonForExportMonthly() {
      var parent = document.getElementById('table-monthly');
      var child = document.getElementsByTagName('caption')[0];
      if (child != null) {
        parent.removeChild(child);
      }
    },
    removeAllButtonForExportDateRange: function removeAllButtonForExportDateRange() {
      var parent = document.getElementById('table-date-range');
      var child = document.getElementsByTagName('caption')[0];
      if (child != null) {
        parent.removeChild(child);
      }
    },
    removeAllButtonForExportDailyProductSales: function removeAllButtonForExportDailyProductSales() {
      var parent = document.getElementById('table-daily-product-sales');
      var child = document.getElementsByTagName('caption')[0];
      if (child != null) {
        parent.removeChild(child);
      }
    },
    removeAllButtonForExportMonthlyProductSales: function removeAllButtonForExportMonthlyProductSales() {
      var parent = document.getElementById('table-monthly-product-sales');
      var child = document.getElementsByTagName('caption')[0];
      if (child != null) {
        parent.removeChild(child);
      }
    },
    removeAllButtonForExportDateRangeProductSales: function removeAllButtonForExportDateRangeProductSales() {
      var parent = document.getElementById('table-date-range-product-sales');
      var child = document.getElementsByTagName('caption')[0];
      if (child != null) {
        parent.removeChild(child);
      }
    },
    calculateAllTotalAttributesMonthly: function calculateAllTotalAttributesMonthly() {
      var totalPrice = 0;
      var totalFinalPrice = 0;
      var totalQuantity = 0;
      var totalDiscount = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.monthly.transactions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var transaction = _step.value;

          totalPrice += parseFloat(transaction.totalPrice);
          totalFinalPrice += parseFloat(transaction.totalFinalPrice);
          totalQuantity += transaction.totalQuantity;
          totalDiscount += parseFloat(transaction.totalDiscount);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.monthly.totalPrice = parseFloat(totalPrice).toFixed(2);
      this.monthly.totalFinalPrice = parseFloat(totalFinalPrice).toFixed(2);
      this.monthly.totalQuantity = parseInt(totalQuantity);
      this.monthly.totalDiscount = parseFloat(totalDiscount).toFixed(2);
    },
    calculateAllTotalAttributesYearly: function calculateAllTotalAttributesYearly() {
      var totalPrice = 0;
      var totalFinalPrice = 0;
      var totalQuantity = 0;
      var totalDiscount = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.yearly.transactions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var transaction = _step2.value;

          totalPrice += parseFloat(transaction.totalPrice);
          totalFinalPrice += parseFloat(transaction.totalFinalPrice);
          totalQuantity += transaction.totalQuantity;
          totalDiscount += parseFloat(transaction.totalDiscount);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.yearly.totalPrice = parseFloat(totalPrice).toFixed(2);
      this.yearly.totalFinalPrice = parseFloat(totalFinalPrice).toFixed(2);
      this.yearly.totalQuantity = parseInt(totalQuantity);
      this.yearly.totalDiscount = parseFloat(totalDiscount).toFixed(2);
    },
    calculateAllTotalDailyProductSalesQuantity: function calculateAllTotalDailyProductSalesQuantity() {
      var totalQuantity = 0;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.daily.productSales), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var product = _step3.value;

          totalQuantity += parseInt(product.quantity);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.daily.totalProductSales = totalQuantity;
    },
    calculateAllTotalMonthlyProductSalesQuantity: function calculateAllTotalMonthlyProductSalesQuantity() {
      var totalQuantity = 0;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.monthly.productSales), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var product = _step4.value;

          totalQuantity += parseInt(product.quantity);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.monthly.totalProductSales = totalQuantity;
    },
    calculateAllTotalDateRangeProductSalesQuantity: function calculateAllTotalDateRangeProductSalesQuantity() {
      var totalQuantity = 0;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.dateRange.productSales), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var product = _step5.value;

          totalQuantity += parseInt(product.quantity);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.dateRange.totalProductSales = totalQuantity;
    },
    printDailyBill: function printDailyBill(products) {
      var _this7 = this;

      this.daily.printBillLoading = true;
      var mappedProducts = products.map(function (product) {
        return { name: product.productName,
          price: product.price,
          quantity: product.quantity,
          discount: 0
        };
      });
      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["k" /* printDailyBill */])({ id: this.date, date: this.date, products: mappedProducts }).then(function (response) {
        _this7.daily.printBillLoading = false;
      }).catch(function (e) {
        _this7.$toast('failed to print daily bill');
        _this7.daily.printBillLoading = false;
      });
    },
    syncToHarmony: function syncToHarmony() {
      var _this8 = this;

      this.daily.syncToHarmonyLoading = true;
      Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["l" /* syncToHarmony */])({ date: this.date }).then(function (response) {
        console.log(response);
      }).catch(function (e) {
        _this8.$toast('failed to sync to harmony for date ' + _this8.date);
        _this8.yearly.transaction = [];
      }).finally(function () {
        _this8.daily.syncToHarmonyLoading = false;
      });
    }
  }
});

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Chart_MonthChart__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Chart_TypeChart__ = __webpack_require__(454);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'monthly-chart',
  components: {
    MonthChart: __WEBPACK_IMPORTED_MODULE_0__components_Chart_MonthChart__["a" /* default */],
    TypeChart: __WEBPACK_IMPORTED_MODULE_1__components_Chart_TypeChart__["a" /* default */]
  },
  props: ['date'],
  data: function data() {
    return {
      selected: 'day'
    };
  },

  computed: {
    title: function title() {
      return this.selected === 'day' ? 'Income' : 'Popular';
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_dashboard__ = __webpack_require__(48);




var lineColor = '#63c2de';
var convertHex = function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['date', 'height'],
  methods: {
    render: function render() {
      var _this = this;

      var date = this.date;
      var yearMonth = date.getFullYear() + '-' + (date.getMonth() + 1);
      Object(__WEBPACK_IMPORTED_MODULE_1__services_dashboard__["g" /* getMonthly */])(yearMonth).then(function (response) {
        return {
          labels: response.map(function (transaction) {
            return 'Day ' + new Date(transaction.date).getDate();
          }),
          prices: response.map(function (transaction) {
            return transaction.totalPrice;
          }),
          quantities: response.map(function (transaction) {
            return transaction.totalQuantity;
          }),
          discounts: response.map(function (transaction) {
            return transaction.totalDiscount;
          })
        };
      }).then(function (data) {
        if (_this.$data._chart) {
          _this.$data._chart.destroy();
        }
        _this.renderChart({
          labels: data.labels,
          datasets: [{
            label: 'Sales Price',
            backgroundColor: convertHex(lineColor, 10),
            borderColor: lineColor,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: data.prices
          }]
        }, {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                drawOnChartArea: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5
              },
              gridLines: {
                display: true
              }
            }]
          },
          elements: {
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          }
        });
      });
    }
  },
  watch: {
    date: function date() {
      this.render();
    }
  },
  mounted: function mounted() {
    this.render();
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_dashboard__ = __webpack_require__(48);




var incomeColor = '#63c2de';
var quantityColor = '#c263de';
var convertHex = function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ['date', 'height'],
  methods: {
    render: function render() {
      var _this = this;

      var date = this.date;
      var yearMonth = date.getFullYear() + '-' + (date.getMonth() + 1);
      Object(__WEBPACK_IMPORTED_MODULE_1__services_dashboard__["i" /* getPrimaryIncome */])(yearMonth).then(function (response) {
        var data = {
          labels: [],
          quantity: [],
          income: []
        };

        for (var key in response) {
          data.labels.push(key);
          data.quantity.push(response[key].quantity);
          data.income.push(response[key].total);
        }
        return data;
      }).then(function (data) {
        if (_this.$data._chart) {
          _this.$data._chart.destroy();
        }
        _this.renderChart({
          labels: data.labels,
          datasets: [{
            label: 'Total Income',
            backgroundColor: convertHex(incomeColor, 10),
            borderColor: incomeColor,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: data.income
          }, {
            label: 'Total Product Sold',
            backgroundColor: convertHex(quantityColor, 10),
            borderColor: quantityColor,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: data.quantity
          }]
        }, {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                drawOnChartArea: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5
              },
              gridLines: {
                display: true
              }
            }]
          },
          elements: {
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          }
        });
      });
    }
  },
  watch: {
    date: function date() {
      this.render();
    }
  },
  mounted: function mounted() {
    this.render();
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Chart_YearChart__ = __webpack_require__(457);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'yearly-chart',
  components: {
    YearChart: __WEBPACK_IMPORTED_MODULE_0__components_Chart_YearChart__["a" /* default */]
  },
  props: ['date']
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_dashboard__ = __webpack_require__(48);




var lineColor = '#63c2de';
var convertHex = function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['date', 'height'],
  methods: {
    render: function render() {
      var _this = this;

      var date = this.date;
      var yearMonth = date.getFullYear() + '-' + (date.getMonth() + 1);
      Object(__WEBPACK_IMPORTED_MODULE_1__services_dashboard__["j" /* getYearly */])(yearMonth).then(function (response) {
        return {
          labels: response.map(function (transaction) {
            return _this.monthName(transaction.date);
          }),
          prices: response.map(function (transaction) {
            return transaction.totalPrice;
          }),
          quantities: response.map(function (transaction) {
            return transaction.totalQuantity;
          }),
          discounts: response.map(function (transaction) {
            return transaction.totalDiscount;
          })
        };
      }).then(function (data) {
        if (_this.$data._chart) {
          _this.$data._chart.destroy();
        }
        _this.renderChart({
          labels: data.labels,
          datasets: [{
            label: 'Sales Price',
            backgroundColor: convertHex(lineColor, 10),
            borderColor: lineColor,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: data.prices
          }]
        }, {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                drawOnChartArea: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5
              },
              gridLines: {
                display: true
              }
            }]
          },
          elements: {
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          }
        });
      });
    }
  },
  watch: {
    date: function date() {
      this.render();
    }
  },
  mounted: function mounted() {
    this.render();
  }
});

/***/ }),
/* 272 */,
/* 273 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(47);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    logout: function logout() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__services_auth__["c" /* logout */])().then(function (response) {
        _this.$router.replace({ path: '/login' });
      });
    }
  }
});

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findObject", function() { return findObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImagePath", function() { return getImagePath; });
var findObject = function findObject(object, id) {
  var result = void 0;
  if (object instanceof Array) {
    for (var i = 0; i < object.length; i++) {
      result = findObject(object[i], id);
    }
  } else {
    for (var prop in object) {
      if (prop === 'id') {
        if (object[prop] === id) {
          return object;
        }
      }
      if (object[prop] instanceof Object || object[prop] instanceof Array) {
        result = findObject(object[prop], id);
      }
    }
  }
  return result;
};

var getImagePath = function getImagePath(path) {
  if (path === undefined) {
    return '/static/img/news/default-210.png';
  }
  if (path.startsWith('http')) {
    return path;
  }
  return 'http://api.kopiketjil.com' + path;
};

/***/ }),
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_toast_lib_toast_css__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_toast_lib_toast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_toast_lib_toast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_toast__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_toast__);















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin({
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6__helpers__);
  },
  methods: {
    currency: function currency(price) {
      return parseFloat(price).toFixed(2) + ' ' + __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.outlet.currency;
    },
    monthName: function monthName(month) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(month, 'MM').format('MMMM');
    },
    moment: function moment(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format(format);
    }
  },
  filters: {
    price: function price(_price) {
      if (_price == 0) {
        return 0;
      }
      return parseFloat(_price).toFixed(2);
    },
    currency: function currency(price, _currency) {
      if (!_currency) {
        _currency = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.outlet.region.currency;
      }
      return parseFloat(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' ' + _currency;
    },
    monthName: function monthName(month) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(month, 'MM').format('MMMM');
    },
    moment: function moment(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format(format);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue2_toast___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('Datepicker', __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['Access-Control-Allow-Origin'] = '*';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function (request, next) {
  next(function (response) {});
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3c8176e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(363)
  __webpack_require__(365)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3c8176e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3c8176e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */,
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Full__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Login__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Dashboard__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_NotAuthorized__ = __webpack_require__(472);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Login__["a" /* default */],
    beforeEnter: guest
  }, {
    path: '/',
    redirect: 'dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__containers_Full__["a" /* default */],
    beforeEnter: auth,
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_5__views_Dashboard__["a" /* default */]
    }, {
      path: 'pos',
      redirect: 'pos',
      name: 'POS',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'product',
        name: 'Product',
        component: function component() {
          return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 645));
        }
      }, {
        path: 'category',
        name: 'Category',
        component: function component() {
          return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 646));
        }
      }, {
        path: 'transaction',
        name: 'Transaction',
        component: function component() {
          return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 647));
        }
      }, {
        path: 'history',
        name: 'History',
        component: function component() {
          return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 648));
        }
      }]
    }, {
      path: 'external',
      redirect: 'external',
      name: 'External',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '',
        name: 'External Dashboard',
        component: __WEBPACK_IMPORTED_MODULE_5__views_Dashboard__["a" /* default */]
      }, {
        path: 'product',
        name: 'External Product',
        component: function component() {
          return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 649));
        }
      }, {
        path: 'category',
        name: 'External Category',
        component: function component() {
          return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 650));
        }
      }, {
        path: 'gallery',
        name: 'Gallery',
        component: function component() {
          return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 348));
        }
      }, {
        path: 'gallery/category',
        name: 'Gallery Category',
        component: function component() {
          return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 348));
        }
      }, {
        path: 'news',
        name: 'News',
        component: function component() {
          return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 651));
        }
      }, {
        path: 'video',
        name: 'Video',
        component: function component() {
          return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 652));
        }
      }, {
        path: 'franchise',
        name: 'Franchise',
        component: function component() {
          return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 653));
        }
      }, {
        path: 'transaction',
        name: 'External Transaction',
        component: function component() {
          return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 654));
        }
      }, {
        path: 'history',
        name: 'External Transaction History',
        component: function component() {
          return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 655));
        }
      }, {
        path: 'outlet',
        name: 'Outlet',
        component: function component() {
          return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 656));
        }
      }]
    }, {
      path: 'console',
      name: 'Console',
      component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 657));
      }
    }]
  }, {
    path: '/not-authorized',
    name: 'NotAuthorized',
    component: __WEBPACK_IMPORTED_MODULE_6__views_NotAuthorized__["a" /* default */]
  }]
}));

function auth(to, from, next) {
  var auth = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.auth;

  if (!auth.isLoggedIn && to.path !== '/login') {
    next('/login');
  } else {
    next();
  }
}

function guest(to, from, next) {
  var auth = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.auth;

  if (auth.isLoggedIn && to.path !== '/') {
    next('/');
  } else {
    next();
  }
}

/***/ }),
/* 368 */,
/* 369 */,
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auth", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "outlets", function() { return outlets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "outlet", function() { return outlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeOutletID", function() { return activeOutletID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "externalToken", function() { return externalToken; });
var auth = function auth(state) {
  return state.auth;
};
var outlets = function outlets(state) {
  return state.auth.user.outlets;
};
var outlet = function outlet(state) {
  return state.auth.user.outlets.find(function (outlet) {
    return outlet.id === state.auth.user.outlet;
  });
};
var activeOutletID = function activeOutletID(state) {
  return state.auth.user.outlet;
};
var externalToken = function externalToken(state) {
  return state.auth.externalApiKey;
};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
var LOGIN = function LOGIN(context, callback) {
  context.commit('LOGIN');
};

var LOGOUT = function LOGOUT(context, callback) {
  context.commit('LOGOUT');
};

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGINEX", function() { return LOGINEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeOutlet", function() { return changeOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeIsAllOutlet", function() { return changeIsAllOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ALL_DATA", function() { return CLEAR_ALL_DATA; });
var LOGIN = function LOGIN(state, user) {
  state.auth.isLoggedIn = true;
  state.auth.user = user;
};

var LOGINEX = function LOGINEX(state, token) {
  state.auth.externalApiKey = token;
};

var LOGOUT = function LOGOUT(state) {
  state.auth.isLoggedIn = false;
  state.auth.user = {};
};

var changeOutlet = function changeOutlet(state, outletID) {
  state.auth.user.outlet = +outletID;
};

var changeIsAllOutlet = function changeIsAllOutlet(state, status) {
  state.auth.isAllOutlet = status;
};

var CLEAR_ALL_DATA = function CLEAR_ALL_DATA(state) {
  state.auth.isLoggedIn = false;
  state.auth.accessToken = null;
  state.auth.refreshToken = null;

  state.user.name = '';
};

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(106);



var localStoragePlugin = function localStoragePlugin(store) {
  store.subscribe(function (mutation, state) {
    var syncedData = { auth: state.auth, user: state.user };

    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__state__["a" /* STORAGE_KEY */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(syncedData));

    if (mutation.type === 'CLEAR_ALL_DATA') {
      localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__state__["a" /* STORAGE_KEY */]);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ([localStoragePlugin]);

/***/ }),
/* 374 */,
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428ecde1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428ecde1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428ecde1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer'
  }, {
    title: true,
    name: 'Point Of Sale',
    class: ''
  }, {
    name: 'Product',
    icon: 'icon-cup',
    children: [{
      name: 'Product',
      url: '/pos/product'
    }, {
      name: 'Category',
      url: '/pos/category'
    }]
  }, {
    name: 'Transaction',
    icon: 'icon-basket',
    children: [{
      name: 'Transaction',
      url: '/pos/transaction'
    }, {
      name: 'History',
      url: '/pos/history'
    }]
  }, {
    title: true,
    name: 'External',
    class: ''
  }, {
    name: 'Product',
    icon: 'icon-cup',
    children: [{
      name: 'Product',
      url: '/external/product'
    }, {
      name: 'Category',
      url: '/external/category'
    }]
  }, {
    name: 'Outlets 🆕',
    url: '/external/outlet',
    icon: 'fa fa-map-marker'
  }, {
    name: 'Gallery',
    icon: 'icon-camera',
    children: [{
      name: 'Gallery',
      url: '/external/gallery'
    }, {
      name: 'Category',
      url: '/external/gallery/category'
    }]
  }, {
    name: 'News',
    url: '/external/news',
    icon: 'fa fa-newspaper-o'
  }, {
    name: 'Video',
    url: '/external/video',
    icon: 'fa fa-play'
  }, {
    name: 'Franchise',
    url: '/external/franchise',
    icon: 'fa fa-hand-lizard-o'
  }, {
    name: 'Transaction',
    icon: 'icon-basket',
    children: [{
      name: 'Transaction',
      url: '/external/transaction'
    }, {
      name: 'History',
      url: '/external/history'
    }]
  }]
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1083edeb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1083edeb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1083edeb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('div',{staticClass:"p-3 bg-light text-center font-weight-bold text-muted text-uppercase"},[_vm._v("\n    Available Outlets : \n  ")]),_vm._v(" "),(_vm.isOwner)?_c('label',{staticClass:"p-3 outlet",on:{"click":function($event){_vm.onOutletClick(-1)}}},[_c('div',{staticClass:"message"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("\n        All Outlet\n        "),_c('input',{staticClass:"float-right",attrs:{"name":"outlet","type":"radio"},domProps:{"checked":_vm.isActiveOutlet(-1)}})]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("This option is choosed for reporting purposes")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.outlets),function(outlet){return _c('label',{key:outlet.id,staticClass:"p-3 outlet",on:{"click":function($event){_vm.onOutletClick(outlet.id)}}},[_c('div',{staticClass:"message"},[_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(outlet.address))])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("\n        "+_vm._s(outlet.name)+"\n        "),_c('input',{staticClass:"float-right",attrs:{"name":"outlet","type":"radio"},domProps:{"checked":_vm.isActiveOutlet(outlet.id)}})]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(outlet.region.country.name))])])])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',{staticClass:"text-muted"})])}]


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a315870_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a315870_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a315870_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(111);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7226450a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7226450a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7226450a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b595efa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b595efa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b595efa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('b-modal',{ref:"version",attrs:{"id":"version","title":_vm.getTitle(),"hide-footer":""}},[_c('h5',[_vm._v("[NEW!] Stable 1.0.8")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Now can show, create, edit and remove items in menu product")]),_vm._v(" "),_c('li',[_vm._v("Change dashboard layouts")]),_vm._v(" "),_c('li',[_vm._v("Fix dashboard issues")])]),_vm._v(" "),_c('h5',[_vm._v("Stable 1.0.6")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Insert category")])]),_vm._v(" "),_c('h5',[_vm._v("Stable 1.0.5")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Dashboard export excel as table")]),_vm._v(" "),_c('li',[_vm._v("Using toastr and more exciting UI")])]),_vm._v(" "),_c('h5',[_vm._v("Release 1.0.0")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Our new "),_c('a',{on:{"dblclick":_vm.gotoConsole}},[_vm._v("admin page")])])]),_vm._v(" "),_c('ul')]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":""}},[_vm._v("Bluejack 16-1")]),_vm._v(". Version "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.version",modifiers:{"version":true}}],attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.currentVersion))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":"http://kopiketjil.com"}},[_vm._v("Kopi Ketjil")]),_vm._v(" © 2018 CoreUI creativeLabs.")])}]


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05fc28c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05fc28c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05fc28c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__ = __webpack_require__(114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685b934a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685b934a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685b934a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Account")])]),_vm._v(" "),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Profile")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],2)}
var staticRenderFns = []


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('HeaderDropdown')],1),_vm._v(" "),_c('button',{staticClass:"navbar-toggler aside-menu-toggler",attrs:{"type":"button"},on:{"click":_vm.asideToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})])],1)}
var staticRenderFns = []


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(115);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454effcb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(391)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454effcb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454effcb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad8e1ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad8e1ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad8e1ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e68d84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e68d84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e68d84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134c0783_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134c0783_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134c0783_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a375f5b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a375f5b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a375f5b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a54728_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a54728_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a54728_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10347a52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10347a52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10347a52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[(!_vm.isFranchiseNav)?_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1):(_vm.isOwner)?_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+" (Owner)\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f55e4ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f55e4ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f55e4ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList,on:{"click":_vm.hideMobile}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20550d10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20550d10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20550d10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"classes":_vm.classList.navItem}},[_c('a',{class:_vm.classList.navLink,attrs:{"href":_vm.url}},[_c('i',{class:_vm.classList.icon}),_vm._v(" "+_vm._s(_vm.name))])])}
var staticRenderFns = []


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:(item.label)?[_c('SidebarNavLabel',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"label":item.label,"classes":item.class}})]:[(item.children)?[(_vm.checkUrl(item.name))?_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[(_vm.checkUrl(item.name))?_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1):_vm._e()]]})],2):_vm._e()]:[(_vm.checkUrl(item.name))?_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1):_vm._e()]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(129);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad6ab10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad6ab10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad6ab10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_269a410c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_269a410c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_269a410c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(29);



var URL = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.externalApiUrl + '/api/kopiketjil/';

var login = function login() {
  var params = {
    'email': 'admin@admin.com',
    'password': 'adminadmin'
  };

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(URL + 'login', params, null).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGINEX', response.body.api_key);
    console.log(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state);
  });
};

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('h1',[_vm._v("Login")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Sign In to your account")]),_vm._v(" "),_c('form',{on:{"submit":_vm.submit}},[_c('b-input-group',{staticClass:"mb-3"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"icon-user"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.username),expression:"credentials.username"}],staticClass:"form-control",attrs:{"required":"true","type":"text","placeholder":"Username"},domProps:{"value":(_vm.credentials.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "username", $event.target.value)}}})],1),_vm._v(" "),_c('b-input-group',{staticClass:"mb-2"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"icon-lock"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],staticClass:"form-control",attrs:{"required":"true","type":"password","placeholder":"Password"},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}})],1),_vm._v(" "),_c('b-row',{staticClass:"mb-4",on:{"if":function($event){_vm.error != ''}}},[_c('b-col',{attrs:{"cols":"6"}},[_c('h6',{staticClass:"text-red"},[_vm._v(_vm._s(_vm.error))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticClass:"px-4",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Login")])],1)],1)],1)])],1)],1)],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8daf926_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(428)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8daf926"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8daf926_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8daf926_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 132,
	"./af.js": 132,
	"./ar": 133,
	"./ar-dz": 134,
	"./ar-dz.js": 134,
	"./ar-kw": 135,
	"./ar-kw.js": 135,
	"./ar-ly": 136,
	"./ar-ly.js": 136,
	"./ar-ma": 137,
	"./ar-ma.js": 137,
	"./ar-sa": 138,
	"./ar-sa.js": 138,
	"./ar-tn": 139,
	"./ar-tn.js": 139,
	"./ar.js": 133,
	"./az": 140,
	"./az.js": 140,
	"./be": 141,
	"./be.js": 141,
	"./bg": 142,
	"./bg.js": 142,
	"./bm": 143,
	"./bm.js": 143,
	"./bn": 144,
	"./bn-bd": 145,
	"./bn-bd.js": 145,
	"./bn.js": 144,
	"./bo": 146,
	"./bo.js": 146,
	"./br": 147,
	"./br.js": 147,
	"./bs": 148,
	"./bs.js": 148,
	"./ca": 149,
	"./ca.js": 149,
	"./cs": 150,
	"./cs.js": 150,
	"./cv": 151,
	"./cv.js": 151,
	"./cy": 152,
	"./cy.js": 152,
	"./da": 153,
	"./da.js": 153,
	"./de": 154,
	"./de-at": 155,
	"./de-at.js": 155,
	"./de-ch": 156,
	"./de-ch.js": 156,
	"./de.js": 154,
	"./dv": 157,
	"./dv.js": 157,
	"./el": 158,
	"./el.js": 158,
	"./en-au": 159,
	"./en-au.js": 159,
	"./en-ca": 160,
	"./en-ca.js": 160,
	"./en-gb": 161,
	"./en-gb.js": 161,
	"./en-ie": 162,
	"./en-ie.js": 162,
	"./en-il": 163,
	"./en-il.js": 163,
	"./en-in": 164,
	"./en-in.js": 164,
	"./en-nz": 165,
	"./en-nz.js": 165,
	"./en-sg": 166,
	"./en-sg.js": 166,
	"./eo": 167,
	"./eo.js": 167,
	"./es": 168,
	"./es-do": 169,
	"./es-do.js": 169,
	"./es-mx": 170,
	"./es-mx.js": 170,
	"./es-us": 171,
	"./es-us.js": 171,
	"./es.js": 168,
	"./et": 172,
	"./et.js": 172,
	"./eu": 173,
	"./eu.js": 173,
	"./fa": 174,
	"./fa.js": 174,
	"./fi": 175,
	"./fi.js": 175,
	"./fil": 176,
	"./fil.js": 176,
	"./fo": 177,
	"./fo.js": 177,
	"./fr": 178,
	"./fr-ca": 179,
	"./fr-ca.js": 179,
	"./fr-ch": 180,
	"./fr-ch.js": 180,
	"./fr.js": 178,
	"./fy": 181,
	"./fy.js": 181,
	"./ga": 182,
	"./ga.js": 182,
	"./gd": 183,
	"./gd.js": 183,
	"./gl": 184,
	"./gl.js": 184,
	"./gom-deva": 185,
	"./gom-deva.js": 185,
	"./gom-latn": 186,
	"./gom-latn.js": 186,
	"./gu": 187,
	"./gu.js": 187,
	"./he": 188,
	"./he.js": 188,
	"./hi": 189,
	"./hi.js": 189,
	"./hr": 190,
	"./hr.js": 190,
	"./hu": 191,
	"./hu.js": 191,
	"./hy-am": 192,
	"./hy-am.js": 192,
	"./id": 193,
	"./id.js": 193,
	"./is": 194,
	"./is.js": 194,
	"./it": 195,
	"./it-ch": 196,
	"./it-ch.js": 196,
	"./it.js": 195,
	"./ja": 197,
	"./ja.js": 197,
	"./jv": 198,
	"./jv.js": 198,
	"./ka": 199,
	"./ka.js": 199,
	"./kk": 200,
	"./kk.js": 200,
	"./km": 201,
	"./km.js": 201,
	"./kn": 202,
	"./kn.js": 202,
	"./ko": 203,
	"./ko.js": 203,
	"./ku": 204,
	"./ku.js": 204,
	"./ky": 205,
	"./ky.js": 205,
	"./lb": 206,
	"./lb.js": 206,
	"./lo": 207,
	"./lo.js": 207,
	"./lt": 208,
	"./lt.js": 208,
	"./lv": 209,
	"./lv.js": 209,
	"./me": 210,
	"./me.js": 210,
	"./mi": 211,
	"./mi.js": 211,
	"./mk": 212,
	"./mk.js": 212,
	"./ml": 213,
	"./ml.js": 213,
	"./mn": 214,
	"./mn.js": 214,
	"./mr": 215,
	"./mr.js": 215,
	"./ms": 216,
	"./ms-my": 217,
	"./ms-my.js": 217,
	"./ms.js": 216,
	"./mt": 218,
	"./mt.js": 218,
	"./my": 219,
	"./my.js": 219,
	"./nb": 220,
	"./nb.js": 220,
	"./ne": 221,
	"./ne.js": 221,
	"./nl": 222,
	"./nl-be": 223,
	"./nl-be.js": 223,
	"./nl.js": 222,
	"./nn": 224,
	"./nn.js": 224,
	"./oc-lnc": 225,
	"./oc-lnc.js": 225,
	"./pa-in": 226,
	"./pa-in.js": 226,
	"./pl": 227,
	"./pl.js": 227,
	"./pt": 228,
	"./pt-br": 229,
	"./pt-br.js": 229,
	"./pt.js": 228,
	"./ro": 230,
	"./ro.js": 230,
	"./ru": 231,
	"./ru.js": 231,
	"./sd": 232,
	"./sd.js": 232,
	"./se": 233,
	"./se.js": 233,
	"./si": 234,
	"./si.js": 234,
	"./sk": 235,
	"./sk.js": 235,
	"./sl": 236,
	"./sl.js": 236,
	"./sq": 237,
	"./sq.js": 237,
	"./sr": 238,
	"./sr-cyrl": 239,
	"./sr-cyrl.js": 239,
	"./sr.js": 238,
	"./ss": 240,
	"./ss.js": 240,
	"./sv": 241,
	"./sv.js": 241,
	"./sw": 242,
	"./sw.js": 242,
	"./ta": 243,
	"./ta.js": 243,
	"./te": 244,
	"./te.js": 244,
	"./tet": 245,
	"./tet.js": 245,
	"./tg": 246,
	"./tg.js": 246,
	"./th": 247,
	"./th.js": 247,
	"./tk": 248,
	"./tk.js": 248,
	"./tl-ph": 249,
	"./tl-ph.js": 249,
	"./tlh": 250,
	"./tlh.js": 250,
	"./tr": 251,
	"./tr.js": 251,
	"./tzl": 252,
	"./tzl.js": 252,
	"./tzm": 253,
	"./tzm-latn": 254,
	"./tzm-latn.js": 254,
	"./tzm.js": 253,
	"./ug-cn": 255,
	"./ug-cn.js": 255,
	"./uk": 256,
	"./uk.js": 256,
	"./ur": 257,
	"./ur.js": 257,
	"./uz": 258,
	"./uz-latn": 259,
	"./uz-latn.js": 259,
	"./uz.js": 258,
	"./vi": 260,
	"./vi.js": 260,
	"./x-pseudo": 261,
	"./x-pseudo.js": 261,
	"./yo": 262,
	"./yo.js": 262,
	"./zh-cn": 263,
	"./zh-cn.js": 263,
	"./zh-hk": 264,
	"./zh-hk.js": 264,
	"./zh-mo": 265,
	"./zh-mo.js": 265,
	"./zh-tw": 266,
	"./zh-tw.js": 266
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 438;

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyChart_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d18e1126_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyChart_vue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d18e1126_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyChart_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d18e1126_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyChart_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthChart_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthChart_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@3.1.0","C:\\Users\\golzw\\Documents\\Repository\\kopiketjil\\coffee-ketjil-admin"]],"_from":"vue-chartjs@3.1.0","_id":"vue-chartjs@3.1.0","_inBundle":false,"_integrity":"sha512-cp70zluNJdN57J907hSzjp4jayF6O0ayBJ/alZprHx+BvbVe+nL+QF3TOPSSao3UoenCopYJybmDi/RWYb7afw==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.1.0","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.1.0","saveSpec":null,"fetchSpec":"3.1.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.1.0.tgz","_spec":"3.1.0","_where":"C:\\Users\\golzw\\Documents\\Repository\\kopiketjil\\coffee-ketjil-admin","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^5.1.1","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.x"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && cross-env NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.1.0"}

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeChart_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeChart_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',{staticClass:"text-left",attrs:{"sm":"5"}},[_c('h4',{staticClass:"card-title",attrs:{"id":"traffic"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm._f("moment")(_vm.date,'MMMM (YYYY)')))])]),_vm._v(" "),_c('b-col',{staticClass:"d-none d-md-block",attrs:{"sm":"7"}},[_c('b-button-toolbar',{staticClass:"float-right"},[_c('b-form-radio-group',{attrs:{"id":"radiosBtn","buttons":"","button-variant":"outline-secondary","name":"radiosBtn"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('b-form-radio',{staticClass:"mx-0",attrs:{"value":"day"}},[_vm._v("Day")]),_vm._v(" "),_c('b-form-radio',{staticClass:"mx-0",attrs:{"value":"type"}},[_vm._v("Type")])],1)],1)],1)],1),_vm._v(" "),_c('month-chart',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected=='day'),expression:"selected=='day'"}],staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"height":"300","date":_vm.date}}),_vm._v(" "),_c('type-chart',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected=='type'),expression:"selected=='type'"}],staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"height":"300","date":_vm.date}})],1)}
var staticRenderFns = []


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearlyChart_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c00e6186_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearlyChart_vue__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearlyChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c00e6186_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearlyChart_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c00e6186_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearlyChart_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearChart_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearChart_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',{staticClass:"text-left",attrs:{"sm":"5"}},[_c('h4',{staticClass:"card-title",attrs:{"id":"traffic"}},[_vm._v("Income")]),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm._f("moment")(_vm.date,'YYYY')))])])],1),_vm._v(" "),_c('year-chart',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"height":"300","date":_vm.date}})],1)}
var staticRenderFns = []


/***/ }),
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 470 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',[_c('b-tab',{staticClass:"text-center",attrs:{"title":"Daily Report","active":""}},[_c('h4',[_vm._v("Daily Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form',{staticStyle:{"justify-content":"space-between"},attrs:{"inline":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_c('datepicker',{model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"success"},on:{"click":_vm.generateDailyReport}},[_vm._v("\n            Generate Report\n          ")])],1),_vm._v(" "),_c('b-button',{staticClass:"float-right",staticStyle:{"display":"none"},attrs:{"size":"md","variant":"outline-success","disabled":_vm.daily.syncToHarmonyLoading},on:{"click":_vm.syncToHarmony}},[(_vm.daily.syncToHarmonyLoading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_vm._v("\n          Sync to Harmony\n        ")],1)],1),_vm._v(" "),(_vm.daily.transactions.length > 0)?_c('div',{staticClass:"table-container my-4"},[_c('table',{staticClass:"table",attrs:{"id":"table-daily"}},[_c('thead',[_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_vm._v("No")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Transaction Creation Date")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Transaction Date")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Transaction ID")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Invoice Number")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Barista Name")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Payment Type")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Discount Reason")]),_vm._v(" "),_c('td',{attrs:{"colspan":"7"}},[_vm._v("Detail")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Service Fee")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Rounding")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Grand Total")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Name")]),_vm._v(" "),_c('td',[_vm._v("Quantity")]),_vm._v(" "),_c('td',[_vm._v("Price")]),_vm._v(" "),_c('td',[_vm._v("Discount")]),_vm._v(" "),_c('td',[_vm._v("Adds On")]),_vm._v(" "),_c('td',[_vm._v("Tax")]),_vm._v(" "),_c('td',[_vm._v("Sub Total")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.daily.transactions),function(transaction,key){return [(false)?[(key !== 0)?_c('tr',{key:transaction.id},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Name")]),_vm._v(" "),_c('td',[_vm._v("Quantity")]),_vm._v(" "),_c('td',[_vm._v("Price")]),_vm._v(" "),_c('td',[_vm._v("Discount")]),_vm._v(" "),_c('td',[_vm._v("Adds On")]),_vm._v(" "),_c('td',[_vm._v("Tax")]),_vm._v(" "),_c('td',[_vm._v("Sub Total")]),_vm._v(" "),_c('td')]):_vm._e()]:_vm._e(),_vm._v(" "),_vm._l((transaction.products),function(product,idx){return _c('tr',{key:((transaction.id) + "-" + (product.id))},[_c('td',[(idx === 0)?[_vm._v(_vm._s(key + 1))]:_vm._e()],2),_vm._v(" "),_c('td',{attrs:{"title":"transaction.created_at"}},[(idx === 0)?[_vm._v(_vm._s(transaction.created_at))]:_vm._e()],2),_vm._v(" "),_c('td',{attrs:{"title":"transaction.finished_ts"}},[(idx === 0)?[_vm._v(_vm._s(transaction.finished_ts))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.id))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.invoice_number))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.user.name))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.payment))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.discount_reason || '-'))]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(product.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.pivot.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("price")(product.pivot.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.pivot.discount)+" %")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("price")(product.pivot.additional_price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.pivot.tax))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("price")(product.pivot.final_price)))]),_vm._v(" "),_c('td',{staticClass:"no-wrap"},[(idx === 0)?[_vm._v(_vm._s(transaction.service_fee))]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"no-wrap"},[(idx === 0)?[_vm._v(_vm._s(transaction.rounding))]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"no-wrap"},[(idx === 0)?[_vm._v(_vm._s(_vm._f("currency")(transaction.subTotal)))]:_vm._e()],2)])})]}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-right",attrs:{"colspan":"15"}},[_vm._v("\n              Total Income\n            ")]),_vm._v(" "),_c('td',{staticClass:"total-price no-wrap"},[_vm._v("\n              "+_vm._s(_vm._f("currency")(_vm.daily.totalPrice))+"\n            ")])]),_vm._v(" "),(_vm.daily.paymentMethods)?_vm._l((_vm.daily.paymentMethods),function(method,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-right",attrs:{"colspan":"12"}},[_vm._v("\n                Total "+_vm._s(method.name)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"total-price no-wrap"},[_vm._v("\n                "+_vm._s(_vm._f("currency")(method.value))+"\n              ")])])}):_vm._e()],2)]),_vm._v(" "),(_vm.daily.isAvailableForExcel)?_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":function($event){_vm.downloadAsExcelDaily(false)}}},[_vm._v("\n            Show Download's Optional Buttons\n          ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":function($event){_vm.downloadJson()}}},[_vm._v("\n            Download Report Raw\n          ")])],1)]):(_vm.daily.transactions.length > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.daily.isLoaded),expression:"daily.isLoaded"}],staticClass:"my-4"},[_c('h4',[_vm._v("Oops, it looks like there are no transactions that can be shown")])]):_vm._e(),_vm._v(" "),(_vm.daily.productSales.length > 0)?_c('div',{staticClass:"table-container my-4"},[_c('table',{staticClass:"table",attrs:{"id":"table-daily-product-sales"}},[_c('thead',[_c('tr',{staticClass:"table-header text-center bold"},[_c('td',{attrs:{"colspan":"3"}},[_vm._v("Popular Products on "+_vm._s(_vm._f("moment")(_vm.date,'DD MMMM YYYY'))+" at "+_vm._s(_vm.activeOutlet))])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-header"},[_c('td',{staticClass:"no"},[_vm._v("No")]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("Product/Beverages Name")]),_vm._v(" "),_c('td',{staticClass:"total-sales"},[_vm._v("Sales Quantity")])]),_vm._v(" "),_vm._l((_vm.daily.productSales),function(product,key){return _c('tr',{key:("" + key),class:{ odd: key%2==0 }},[_c('td',[_vm._v(_vm._s((key + 1)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.quantity))])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Total Sales Quantity")]),_vm._v(" "),_c('td',{staticClass:"total-quantity"},[_vm._v(_vm._s(_vm.daily.totalProductSales))])])],2)]),_vm._v(" "),(_vm.daily.isAvailableForExcelProductSales)?_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":_vm.downloadAsExcelDailyProductSales}},[_vm._v("\n            Show Download's Optional Buttons\n          ")]),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"outline-info","disabled":_vm.daily.printBillLoading},on:{"click":function($event){_vm.printDailyBill(_vm.daily.productSales)}}},[(_vm.daily.printBillLoading)?_c('b-spinner',{attrs:{"small":""}}):_c('i',{staticClass:"icon-printer"}),_vm._v(" Print Daily\n          ")],1)],1):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('b-tab',{staticClass:"text-center",attrs:{"title":"Monthly Report"}},[_c('h4',[_vm._v("Monthly Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('monthly-chart',{attrs:{"date":_vm.month}}),_vm._v(" "),_c('b-form',{attrs:{"inline":""}},[_c('datepicker',{attrs:{"minimumView":'month',"maximumView":'month'},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}}),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"success"},on:{"click":_vm.generateMonthlyReport}},[_vm._v("\n          Generate Report\n        ")])],1),_vm._v(" "),(_vm.monthly.transactions.length > 0)?_c('div',{staticClass:"table-container my-4"},[_c('table',{staticClass:"table",attrs:{"id":"table-monthly"}},[_c('thead',[_c('tr',{staticClass:"table-header"},[_c('td',{staticClass:"no"},[_vm._v("No")]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("Transaction Date")]),_vm._v(" "),_c('td',{staticClass:"total-sales"},[_vm._v("Total Sales")]),_vm._v(" "),_c('td',{staticClass:"total-sales"},[_vm._v("Total Sales (After Tax)")]),_vm._v(" "),_c('td',{staticClass:"sales-quantity"},[_vm._v("Sales Quantity")]),_vm._v(" "),_c('td',{staticClass:"total-discount"},[_vm._v("Total Discounts")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.monthly.transactions),function(transaction,key){return _c('tr',{key:transaction.id,class:{ odd: key%2==0 }},[_c('td',{staticClass:"no"},[_vm._v(_vm._s((key + 1)))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(transaction.date))]),_vm._v(" "),_c('td',{staticClass:"sub-price"},[_vm._v(_vm._s(_vm._f("currency")(transaction.totalPrice)))]),_vm._v(" "),_c('td',{staticClass:"sub-price"},[_vm._v(_vm._s(_vm._f("currency")(transaction.totalFinalPrice)))]),_vm._v(" "),_c('td',{staticClass:"sub-quantity"},[_vm._v(_vm._s(transaction.totalQuantity))]),_vm._v(" "),_c('td',{staticClass:"sub-discount"},[_vm._v(_vm._s(_vm._f("currency")(transaction.totalDiscount)))])])}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"right",attrs:{"colspan":"2"}},[_vm._v("\n              Total\n            ")]),_vm._v(" "),_c('td',{staticClass:"total-price"},[_vm._v(_vm._s(_vm._f("currency")(this.monthly.totalPrice)))]),_vm._v(" "),_c('td',{staticClass:"total-price"},[_vm._v(_vm._s(_vm._f("currency")(this.monthly.totalFinalPrice)))]),_vm._v(" "),_c('td',{staticClass:"total-quantity"},[_vm._v(_vm._s(this.monthly.totalQuantity))]),_vm._v(" "),_c('td',{staticClass:"total-discount"},[_vm._v(_vm._s(_vm._f("currency")(this.monthly.totalDiscount)))])])],2)]),_vm._v(" "),(_vm.monthly.isAvailableForExcel)?_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":_vm.downloadAsExcelMonthly}},[_vm._v("\n            Show Download's Optional Buttons\n          ")])],1):_vm._e()]):(_vm.monthly.transactions.length > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.monthly.isLoaded),expression:"monthly.isLoaded"}],staticClass:"my-4"},[_c('h4',[_vm._v("Oops, it looks like there are no transactions that can be shown")])]):_vm._e(),_vm._v(" "),(_vm.monthly.productSales.length > 0)?_c('div',{staticClass:"table-container my-4"},[_c('table',{staticClass:"table",attrs:{"id":"table-monthly-product-sales"}},[_c('thead',[_c('tr',{staticClass:"table-header text-center bold"},[_c('td',{attrs:{"colspan":"3"}},[_vm._v("Popular Products on "+_vm._s(_vm._f("moment")(_vm.month,'MMMM YYYY'))+" at "+_vm._s(_vm.activeOutlet))])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-header"},[_c('td',{staticClass:"no"},[_vm._v("No")]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("Product/Beverages Name")]),_vm._v(" "),_c('td',{staticClass:"total-sales"},[_vm._v("Sales Quantity")])]),_vm._v(" "),_vm._l((_vm.monthly.productSales),function(product,key){return _c('tr',{key:key,class:{ odd: key%2==0 }},[_c('td',[_vm._v(_vm._s((key + 1)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.quantity))])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Total Sales Quantity")]),_vm._v(" "),_c('td',{staticClass:"total-quantity"},[_vm._v(_vm._s(_vm.monthly.totalProductSales))])])],2)]),_vm._v(" "),(_vm.monthly.isAvailableForExcelProductSales)?_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":_vm.downloadAsExcelMonthlyProductSales}},[_vm._v("\n            Show Download's Optional Buttons\n          ")])],1):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('b-tab',{staticClass:"text-center",attrs:{"title":"Yearly Report"}},[_c('h4',[_vm._v("Yearly Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('yearly-chart',{attrs:{"date":_vm.year}}),_vm._v(" "),_c('b-form',{attrs:{"inline":""}},[_c('datepicker',{attrs:{"minimumView":'year',"maximumView":'year'},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}}),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"success"},on:{"click":_vm.generateYearlyReport}},[_vm._v("\n          Generate Report\n        ")])],1),_vm._v(" "),(_vm.yearly.transactions.length > 0)?_c('div',{staticClass:"table-container my-4"},[_c('table',{staticClass:"table",attrs:{"id":"table-monthly-2"}},[_c('thead',[_c('tr',{staticClass:"table-header"},[_c('td',{staticClass:"no"},[_vm._v("No")]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("Transaction Month")]),_vm._v(" "),_c('td',{staticClass:"total-sales"},[_vm._v("Total Sales")]),_vm._v(" "),_c('td',{staticClass:"total-sales"},[_vm._v("Total Sales (After Tax)")]),_vm._v(" "),_c('td',{staticClass:"sales-quantity"},[_vm._v("Sales Quantity")]),_vm._v(" "),_c('td',{staticClass:"total-discount"},[_vm._v("Total Discounts")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.yearly.transactions),function(transaction,key){return _c('tr',{key:transaction.id,class:{ odd: key%2==0 }},[_c('td',{staticClass:"no"},[_vm._v(_vm._s((key + 1)))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("monthName")(transaction.date)))]),_vm._v(" "),_c('td',{staticClass:"sub-price"},[_vm._v(_vm._s(_vm._f("currency")(transaction.totalPrice)))]),_vm._v(" "),_c('td',{staticClass:"sub-price"},[_vm._v(_vm._s(_vm._f("currency")(transaction.totalFinalPrice)))]),_vm._v(" "),_c('td',{staticClass:"sub-quantity"},[_vm._v(_vm._s(transaction.totalQuantity))]),_vm._v(" "),_c('td',{staticClass:"sub-discount"},[_vm._v(_vm._s(_vm._f("currency")(transaction.totalDiscount)))])])}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"right",attrs:{"colspan":"2"}},[_vm._v("\n              Total\n            ")]),_vm._v(" "),_c('td',{staticClass:"total-price"},[_vm._v(_vm._s(_vm._f("currency")(this.yearly.totalPrice)))]),_vm._v(" "),_c('td',{staticClass:"total-price"},[_vm._v(_vm._s(_vm._f("currency")(this.yearly.totalFinalPrice)))]),_vm._v(" "),_c('td',{staticClass:"total-quantity"},[_vm._v(_vm._s(this.yearly.totalQuantity))]),_vm._v(" "),_c('td',{staticClass:"total-discount"},[_vm._v(_vm._s(_vm._f("currency")(this.yearly.totalDiscount)))])])],2)]),_vm._v(" "),(_vm.yearly.isAvailableForExcel)?_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":_vm.downloadAsExcelMonthly}},[_vm._v("\n            Show Download's Optional Buttons\n          ")])],1):_vm._e()]):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.yearly.isLoaded),expression:"yearly.isLoaded"}],staticClass:"my-4"},[_c('h4',[_vm._v("Oops, it looks like there are no transactions that can be shown")])])],1),_vm._v(" "),_c('b-tab',{staticClass:"text-center",attrs:{"title":"Daily Report (Third Party)"}},[_c('h4',[_vm._v("Daily Report (Third Party)")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form',{attrs:{"inline":""}},[_c('datepicker',{model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"success"},on:{"click":_vm.generateDailyThirdPartyReport}},[_vm._v("\n          Generate Report\n        ")])],1),_vm._v(" "),(_vm.dailyThirdParty.transactions.length > 0)?_c('div',{staticClass:"table-container my-4"},[_c('table',{staticClass:"table",attrs:{"id":"table-daily-custom"}},[_c('thead',[_c('tr',[_c('td',[_vm._v("InvoiceNo")]),_vm._v(" "),_c('td',[_vm._v("Customer")]),_vm._v(" "),_c('td',[_vm._v("InvoiceDate")]),_vm._v(" "),_c('td',[_vm._v("DueDate")]),_vm._v(" "),_c('td',[_vm._v("Terms")]),_vm._v(" "),_c('td',[_vm._v("Location")]),_vm._v(" "),_c('td',[_vm._v("Memo")]),_vm._v(" "),_c('td',[_vm._v("Item(Product/Service)")]),_vm._v(" "),_c('td',[_vm._v("ItemDescription")]),_vm._v(" "),_c('td',[_vm._v("ItemQuantity")]),_vm._v(" "),_c('td',[_vm._v("ItemRate")]),_vm._v(" "),_c('td',[_vm._v("ItemAmount")]),_vm._v(" "),_c('td',[_vm._v("ItemTaxCode")]),_vm._v(" "),_c('td',[_vm._v("ItemTaxAmount")]),_vm._v(" "),_c('td',[_vm._v("ItemServiceFee")]),_vm._v(" "),_c('td',[_vm._v("Rounding")]),_vm._v(" "),_c('td',[_vm._v("Service Date")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.dailyThirdParty.transactions),function(transaction,key){return _c('tr',{class:{ odd: key % 2==0 }},[_c('td',[_vm._v(_vm._s(transaction.InvoiceNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.Customer))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.InvoiceDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.DueDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.Terms))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.Location))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.Memo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction['Item(Product/Service)']))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.ItemDescription))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.ItemQuantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("price")(transaction.ItemRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("price")(transaction.ItemAmount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.ItemTaxCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.ItemTaxAmount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.ItemServiceFee))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.Rounding))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction['Service Date'].date))])])}))]),_vm._v(" "),(_vm.dailyThirdParty.isAvailableForExcel)?_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":function($event){_vm.downloadAsExcelDaily('custom')}}},[_vm._v("\n            Show Download's Optional Buttons\n          ")])],1):_vm._e()]):(_vm.dailyThirdParty.transactions.length > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dailyThirdParty.isLoaded),expression:"dailyThirdParty.isLoaded"}],staticClass:"my-4"},[_c('h4',[_vm._v("Oops, it looks like there are no transactions that can be shown")])]):_vm._e()],1),_vm._v(" "),_c('b-tab',{staticClass:"text-center",attrs:{"title":"Date Range Report"}},[_c('h4',[_vm._v("Date Range Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form',{attrs:{"inline":""}},[_c('datepicker',{model:{value:(_vm.dateStart),callback:function ($$v) {_vm.dateStart=$$v},expression:"dateStart"}}),_vm._v(" "),_c('datepicker',{attrs:{"disabled-dates":_vm.disabledDates},model:{value:(_vm.dateEnd),callback:function ($$v) {_vm.dateEnd=$$v},expression:"dateEnd"}}),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"success"},on:{"click":_vm.generateDateRangeReport}},[_vm._v("\n          Generate Report\n        ")])],1),_vm._v(" "),(_vm.dateRange.transactions.length > 0)?_c('div',{staticClass:"table-container my-4"},[_c('table',{staticClass:"table",attrs:{"id":"table-date-range"}},[_c('thead',[_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_vm._v("No")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Transaction Date")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Transaction ID")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Invoice Number")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Barista Name")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Payment Type")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Discount Reason")]),_vm._v(" "),_c('td',{attrs:{"colspan":"7"}},[_vm._v("Detail")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Service Fee")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Rounding")]),_vm._v(" "),_c('td',{attrs:{"rowspan":"2"}},[_vm._v("Grand Total")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Name")]),_vm._v(" "),_c('td',[_vm._v("Quantity")]),_vm._v(" "),_c('td',[_vm._v("Price")]),_vm._v(" "),_c('td',[_vm._v("Discount")]),_vm._v(" "),_c('td',[_vm._v("Adds On")]),_vm._v(" "),_c('td',[_vm._v("Tax")]),_vm._v(" "),_c('td',[_vm._v("Sub Total")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.dateRange.transactions),function(transaction,key){return [(key !== 0)?_c('tr',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],key:transaction.id},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Name")]),_vm._v(" "),_c('td',[_vm._v("Quantity")]),_vm._v(" "),_c('td',[_vm._v("Price")]),_vm._v(" "),_c('td',[_vm._v("Discount")]),_vm._v(" "),_c('td',[_vm._v("Adds On")]),_vm._v(" "),_c('td',[_vm._v("Tax")]),_vm._v(" "),_c('td',[_vm._v("Sub Total")]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),_vm._l((transaction.products),function(product,idx){return _c('tr',{key:((transaction.id) + "-" + (product.id) + "-" + idx)},[_c('td',[(idx === 0)?[_vm._v(_vm._s(key + 1))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.created_at))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.id))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.invoice_number))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.user.name))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.payment))]:_vm._e()],2),_vm._v(" "),_c('td',[(idx === 0)?[_vm._v(_vm._s(transaction.discount_reason || '-'))]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(product.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.pivot.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("price")(product.pivot.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.pivot.discount)+" %")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("price")(product.pivot.additional_price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.pivot.tax))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("price")(product.pivot.final_price)))]),_vm._v(" "),_c('td',{staticClass:"no-wrap"},[(idx === 0)?[_vm._v(_vm._s(transaction.service_fee))]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"no-wrap"},[(idx === 0)?[_vm._v(_vm._s(transaction.rounding))]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"no-wrap"},[(idx === 0)?[_vm._v(_vm._s(_vm._f("currency")(transaction.subTotal)))]:_vm._e()],2)])})]}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-right",attrs:{"colspan":"15"}},[_vm._v("\n              Total Income\n            ")]),_vm._v(" "),_c('td',{staticClass:"total-price no-wrap"},[_vm._v("\n              "+_vm._s(_vm._f("currency")(_vm.dateRange.totalPrice))+"\n            ")])]),_vm._v(" "),(_vm.dateRange.paymentMethods)?_vm._l((_vm.dateRange.paymentMethods),function(method,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-right",attrs:{"colspan":"15"}},[_vm._v("\n                Total "+_vm._s(method.name)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"total-price no-wrap"},[_vm._v("\n                "+_vm._s(_vm._f("currency")(method.value))+"\n              ")])])}):_vm._e()],2)]),_vm._v(" "),(_vm.dateRange.isAvailableForExcel)?_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":function($event){_vm.downloadAsExcelDateRange()}}},[_vm._v("\n            Show Download's Optional Buttons\n          ")])],1):_vm._e()]):(_vm.dateRange.transactions.length > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dateRange.isLoaded),expression:"dateRange.isLoaded"}],staticClass:"my-4"},[_c('h4',[_vm._v("Oops, it looks like there are no transactions that can be shown")])]):_vm._e(),_vm._v(" "),(_vm.dateRange.categorySales.length > 0)?_c('div',{staticClass:"table-container my-4"},[_c('table',{staticClass:"table",attrs:{"id":"table-date-range-category-sales"}},[_c('thead',[_c('tr',{staticClass:"table-header text-center bold"},[_c('td',{staticClass:"center",attrs:{"colspan":"5"}},[_vm._v("Popular Categories at "+_vm._s(_vm.activeOutlet))])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-header"},[_c('td',{staticClass:"no"},[_vm._v("No")]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("Primary")]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("Secondary")]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("Tertiary")]),_vm._v(" "),_c('td',{staticClass:"total-sales qty"},[_vm._v("Quantity")])]),_vm._v(" "),_vm._l((_vm.dateRange.categorySales),function(category,key){return [_c('tr',{key:key,staticClass:"level-1",class:{ odd: key % 2 === 0 }},[_c('td',[_vm._v(_vm._s((key + 1)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(category.categoryName)+" "),_c('small',[_vm._v("("+_vm._s(_vm._f("currency")(category.total_sales))+")")])]),_vm._v(" "),_c('td',{staticClass:"qty",attrs:{"colspan":"3"}},[_vm._v(_vm._s(category.total))])]),_vm._v(" "),_vm._l((category.children),function(child,childKey){return (category.children && category.children.length)?[_c('tr',{key:childKey,staticClass:"level-2",class:{ odd: key % 2 === 0 }},[_c('td',{staticClass:"qty",attrs:{"colspan":"2"}},[_vm._v("↳")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(child.categoryName)+" "),_c('small',[_vm._v("("+_vm._s(_vm._f("currency")(child.total_sales))+")")])]),_vm._v(" "),_c('td',{staticClass:"qty",attrs:{"colspan":"2"}},[_vm._v(_vm._s(child.total))])]),_vm._v(" "),(child.children && child.children.length)?_vm._l((child.children),function(grandChild,grandChildKey){return _c('tr',{key:grandChildKey,staticClass:"level-3",class:{ odd: key % 2 === 0 }},[_c('td',{staticClass:"qty",attrs:{"colspan":"3"}},[_vm._v("↳")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grandChild.categoryName)+" "),_c('small',[_vm._v("("+_vm._s(_vm._f("currency")(grandChild.total_sales))+")")])]),_vm._v(" "),_c('td',{staticClass:"qty"},[_vm._v(_vm._s(grandChild.total))])])}):_vm._e()]:_vm._e()})]})],2)]),_vm._v(" "),(_vm.dateRange.isAvailableForExcelCategorySales)?_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":_vm.downloadAsExcelDateRangeCategorySales}},[_vm._v("\n            Show Download's Optional Buttons\n          ")])],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.dateRange.productSales.length > 0)?_c('div',{staticClass:"table-container my-4"},[_c('table',{staticClass:"table",attrs:{"id":"table-date-range-product-sales"}},[_c('thead',[_c('tr',{staticClass:"table-header text-center bold"},[_c('td',{attrs:{"colspan":"3"}},[_vm._v("Popular Products on "+_vm._s(_vm._f("moment")(_vm.dateStart,'MMMM YYYY'))+" - "+_vm._s(_vm._f("moment")(_vm.dateEnd,'MMMM YYYY'))+" at "+_vm._s(_vm.activeOutlet))])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-header"},[_c('td',{staticClass:"no"},[_vm._v("No")]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("Product/Beverages Name")]),_vm._v(" "),_c('td',{staticClass:"total-sales"},[_vm._v("Sales Quantity")])]),_vm._v(" "),_vm._l((_vm.dateRange.productSales),function(product,key){return _c('tr',{key:key,class:{ odd: key%2==0 }},[_c('td',[_vm._v(_vm._s((key + 1)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.quantity))])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("Total Sales Quantity")]),_vm._v(" "),_c('td',{staticClass:"total-quantity"},[_vm._v(_vm._s(_vm.dateRange.totalProductSales))])])],2)]),_vm._v(" "),(_vm.dateRange.isAvailableForExcelProductSales)?_c('div',{staticClass:"my-2"},[_c('b-button',{attrs:{"size":"md","variant":"info"},on:{"click":_vm.downloadAsExcelDateRangeProductSales}},[_vm._v("\n            Show Download's Optional Buttons\n          ")])],1):_vm._e()]):_vm._e()],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotAuthorized_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3497cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotAuthorized_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotAuthorized_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3497cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotAuthorized_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3497cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotAuthorized_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('h1',[_vm._v("Not Authorized")]),_vm._v(" "),_c('b-button',{staticClass:"px-4",attrs:{"type":"button","variant":"primary"},on:{"click":_vm.logout}},[_vm._v("Logout")])],1)],1)],1)],1)],1)])])}
var staticRenderFns = []


/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */,
/* 476 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[349]);


// WEBPACK FOOTER //
// static/js/app.93b319e731a86ffc1a6e.js